import { getPref, setPref } from '../persistentPrefs';

const STORAGE_KEY = 'fab-accessibility-settings';

// Swatches for the "own cards" side. Cool hues. The default pairs
// with a warm opponent color so the contrast is strong even for
// players with red/green colorblindness. Values are hex strings so
// they can be consumed directly by both CSS (swatch UI) and THREE
// (Color constructor accepts hex strings).
export const OWN_OUTLINE_SWATCHES = [
  { key: 'blue',   value: '#3b82f6' },
  { key: 'cyan',   value: '#06b6d4' },
  { key: 'green',  value: '#22c55e' },
  { key: 'gold',   value: '#eab308' },
  { key: 'white',  value: '#e5e7eb' },
];

// Swatches for the opponent side. Warmer / contrasting palette.
export const OPPONENT_OUTLINE_SWATCHES = [
  { key: 'red',    value: '#ef4444' },
  { key: 'orange', value: '#f97316' },
  { key: 'pink',   value: '#ec4899' },
  { key: 'purple', value: '#a855f7' },
  { key: 'black',  value: '#18181b' },
];

// Thickness is expressed in THREE world units (same space as
// CARD_WIDTH in cardMesh.js, which is ~11). A 0.25 stroke reads as
// "firm but not dominating"; 0.1 is subtle, 0.6 is unmissable.
export const OUTLINE_THICKNESS_MIN = 0.1;
export const OUTLINE_THICKNESS_MAX = 0.6;
export const OUTLINE_THICKNESS_STEP = 0.05;
export const OUTLINE_THICKNESS_DEFAULT = 0.25;

// Playback multipliers for the combat stage. Every scheduled beat and
// animation duration divides by the chosen value, so 2 plays the same
// choreography in half the wall-clock time.
export const COMBAT_SPEEDS = [1, 1.5, 2];

const defaults = {
  ownershipOutlines: false,
  ownOutlineColor: OWN_OUTLINE_SWATCHES[0].value,
  opponentOutlineColor: OPPONENT_OUTLINE_SWATCHES[0].value,
  outlineThickness: OUTLINE_THICKNESS_DEFAULT,
  combatSpeed: 1,
};

let cached = null;
const listeners = new Set();

export function getAccessibilitySettings() {
  if (cached) return cached;
  const stored = getPref(STORAGE_KEY, null);
  cached = stored && typeof stored === 'object' ? { ...defaults, ...stored } : { ...defaults };
  return cached;
}

export function saveAccessibilitySettings(patch) {
  cached = { ...getAccessibilitySettings(), ...patch };
  setPref(STORAGE_KEY, cached);
  for (const fn of listeners) fn(cached);
}

export function onAccessibilityChange(callback) {
  listeners.add(callback);
  return () => listeners.delete(callback);
}
